import { useParams, usePathname } from 'next/navigation';
import React, { FC, useEffect } from 'react';

import { languages } from '@/app/[lang]/dictionaries';
import Image from '@/components/core/Image';
import Link from '@/components/core/Link';
import { getCurrentLanguage, Lang } from '@/lib/i18n';
import { RTL_LANGUAGES } from '@/public/constants';

const HeaderLanguage: FC = () => {
  const { lang } = useParams();
  const path = usePathname();

  useEffect(() => {
    document.dir = (RTL_LANGUAGES[lang as string] && 'rtl') || 'ltr';
    document.documentElement.lang = lang as string;
  }, [lang]);

  return (
    <div className="headerLanguage">
      <div className="languageWrp">
        <div className="countyFlag">
          <Image
            alt=""
            width={30}
            height={22}
            src={getCurrentLanguage(lang as Lang)?.flag || languages[0].flag}
          />
        </div>
        <i className="bc-i-arrow-down" />
        <div className="openLanguageWrp">
          <div className="openLanguageHolder">
            <div className="openLanguageContent">
              {languages.map((item) => (
                <Link href={path.replace(`${lang}`, item.link)} key={item.link} passHref>
                  <div className={`openLanguageRow ${lang === item.link ? 'active' : ''}`}>
                    <div className="countyFlag">
                      <Image src={item.flag} width={30} height={22} alt="" />
                    </div>
                    <i className="bc-i-check" />
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeaderLanguage;
